<script setup lang="ts">
import type { PropType } from 'vue';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import type { Ui2DropdownMenuItem } from '@mop/ui2/types';

defineOptions({
  name: 'Ui2DropdownMenu',
});

defineProps({
  items: {
    type: Array as PropType<Ui2DropdownMenuItem[]>,
    default: () => [],
  },
  hasIconRotation: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div>
    <Menu v-slot="{ open }">
      <div
        :class="[
          'ui-dropdown-menu',
          {
            'ui-dropdown-menu--open': open,
            'ui-dropdown-menu--has-icon-rotation': hasIconRotation,
          },
        ]"
      >
        <MenuButton as="div">
          <slot name="cta" />
        </MenuButton>
        <div class="ui-dropdown-menu__options-wrapper">
          <MenuItems class="ui-dropdown__options">
            <MenuItem v-for="item in items" v-slot="{ active }" :key="item.text" :disabled="item.disabled">
              <Ui2NuxtLink
                v-bind="item.link"
                :class="[
                  'ui-dropdown__option',
                  {
                    'ui-dropdown__option--active': active,
                    'ui-dropdown__option--header': item.isHeader,
                    'ui-dropdown__option--disabled': item.disabled,
                    'ui-dropdown__option--border-top': item.borderTop,
                  },
                ]"
                @click="item.callbackFn ? item.callbackFn() : undefined"
              >
                {{ item.text }}
              </Ui2NuxtLink>
            </MenuItem>
          </MenuItems>
        </div>
      </div>
    </Menu>
  </div>
</template>

<style lang="scss">
@import './ui2dropdown.scss';

.ui-dropdown-menu {
  position: relative;
  display: inline-block;
  color: $color-text-body-primary;
}

.ui-dropdown-menu__options-wrapper {
  @include v2-z(global, abovecontent);

  position: absolute;
  right: 0;
  width: 320px;
  opacity: 0;
  transition: opacity $animation-duration-medium $animation-type-standard;
}

.ui-dropdown-menu--has-icon-rotation {
  .ui-svg-icon {
    transition: transform $animation-duration-medium $animation-type-standard;
  }
}

.ui-dropdown-menu--open {
  .ui-dropdown-menu__options-wrapper {
    opacity: 1;
  }

  &.ui-dropdown-menu--has-icon-rotation {
    .ui-svg-icon {
      transform: rotate(-180deg);
    }
  }
}
</style>
